<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true"></app-doenkids-menu-bar>
<div content>
  <mat-toolbar class="doenkids-toolbar">
  <h2>{{ 'user_activity.heading' | translate }}</h2>
  <span class="spacer"></span>
  <span>{{ 'user_activity.last_change' | translate: {lastUpdated: ((lastUpdatedDisplay$ | async) | from_now | async)} }}</span>
</mat-toolbar>

<app-sortable-list
  class="not-selectable"
  (reload)="getList($event)"
  [fields]="fields$ | async"
  [list$]="list$ | async"
  [metadata]="metaData$ | async"
  sortField="last_seen"
  [defaultLimit]="SEARCH_LIMIT"
  >
  <ng-container *appSortableListFields="let list">
    @if (!(loading$ | async)) {
      @for (event of list | paginate: ( paginationConfig$ | async); track event) {
        <tr>
          <td class="d-none d-md-table-cell">
            <div class="cell-wrapper">{{ event.created_at | from_now | async }}</div>
          </td>
          <td class="d-none d-md-table-cell">
            <div class="cell-wrapper"><a [routerLink]="['/organization/' + event.organization_unit_id + '/overview']">{{event.organization_unit_name }}</a></div>
          </td>
          <td>
            <div class="cell-wrapper">
              <span class="event-type">{{event.event_type | translate}}</span>
              @if (event.activity_id) {
                <div class="event-link cell-wrapper">
                  <a [routerLink]="['/activities/preview/' + event.activity_id]"><mat-icon>filter_none</mat-icon>{{event.activity_id}}</a>
                </div>
              }
              @if (event.program_id) {
                <div class="event-link cell-wrapper">
                  <a [routerLink]="['/organization/' + event.organization_unit_id + '/program/' + event.program_id]"><mat-icon>calendar_today</mat-icon>{{event.program_id}}</a>
                </div>
              }
            </div>
          </td>
          <td>
            <div class="cell-wrapper">{{event.name}}, status code: {{event.response}}</div>
          </td>
        </tr>
      }
      @if (list.length === 0) {
        <tr>
          <td [attr.colspan]="(fields$ | async).length">
            <div class="cell-wrapper">{{ 'user_activity.no_results' | translate }}</div>
          </td>
        </tr>
      }
    }
    @if ((loading$ | async)) {
      <tr>
        <td [attr.colspan]="(fields$ | async).length">
          <div class="cell-wrapper">{{ 'user_activity.loading' | translate }}</div>
        </td>
      </tr>
    }
  </ng-container>
</app-sortable-list>
</div>
</app-page-content>
